import { toast } from "react-hot-toast";
import { Toast } from "@/components/atoms";

export const addToast = (type: "success" | "danger" | "info", message: string, duration = 5000) => {
  toast.custom((t) => <Toast type={type} message={message} onClick={() => toast.dismiss(t.id)} visible={t.visible} />, {
    duration: duration,
  });
};
